module.exports = __webpack_public_path__ + "media/images/application2/AppBookingsTalk__panel__header__a-c61380cd08ceb1ea8ff659310448b9a4.svg";